import moment, { Moment } from 'moment';

export type AutomationFrequency = 'daily' | 'weekly' | 'monthly' | 'yearly';

/**
 * Next month-end after a publish (same rules as cixon-finance-server automationSchedule).
 * - Mid-month publish (Force Generate): end of the *current* month (09.09 → 30.09).
 * - Publish already on a month-end: end of the *following* month (31.08 → 30.09).
 */
export function nextMonthlyPublishDate(baseDate: Moment): Moment {
  const day = baseDate.clone().startOf('day');
  const endThisMonth = day.clone().endOf('month').startOf('day');
  if (day.isBefore(endThisMonth, 'day')) {
    return endThisMonth;
  }
  return day.clone().add(1, 'month').endOf('month').startOf('day');
}

/** Next scheduled publish moment from lastPublishedAt + frequency. */
export function getNextPublishingDate(
  lastPublishedAt: Date | string | Moment,
  automationFrequency: AutomationFrequency,
): Moment {
  const baseDate = moment(lastPublishedAt).startOf('day');

  switch (automationFrequency) {
    case 'daily':
      return baseDate.clone().add(1, 'day').endOf('day');
    case 'weekly':
      return baseDate.clone().add(1, 'week').endOf('week');
    case 'monthly':
      return nextMonthlyPublishDate(baseDate);
    case 'yearly':
      return baseDate.clone().add(1, 'year').endOf('year');
    default:
      return baseDate.clone().add(1, 'day').endOf('day');
  }
}

/** True when the computed next publish day is strictly before today (calendar). */
export function isPublishingDateOverdue(
  nextPublishingDate: Date | string | Moment,
  today: Date | string | Moment = moment(),
): boolean {
  return moment(nextPublishingDate).startOf('day').isBefore(moment(today).startOf('day'), 'day');
}
